import {
  ApiConfigurationErrorBody,
  ApiConfigurationErrorPanel,
  ApiConfigurationErrorRoot,
  ApiConfigurationErrorTitle,
} from 'styles/apiConfigurationError';

type ApiConfigurationErrorScreenProps = Readonly<{
  message: string;
}>;

export function ApiConfigurationErrorScreen({ message }: ApiConfigurationErrorScreenProps) {
  return (
    <ApiConfigurationErrorRoot component="main" role="alert">
      <ApiConfigurationErrorPanel>
        <ApiConfigurationErrorTitle component="h1">Configuration error</ApiConfigurationErrorTitle>
        <ApiConfigurationErrorBody>{message}</ApiConfigurationErrorBody>
      </ApiConfigurationErrorPanel>
    </ApiConfigurationErrorRoot>
  );
}
